import React, { useEffect, useState } from 'react';
import './Assessments.css';

export default function Assessments() {
  const [files, setFiles] = useState([]);

  useEffect(() => {
    fetch('/assessments/index.json')
      .then(res => res.json())
      .then(data => setFiles(data))
      .catch(err => console.error('Failed to load file list:', err));
  }, []);

  return (
    <div className="assessments-container">
      <h1>📄 Assessment Summaries</h1>
      <ul className="assessment-list">
        {files.map((filename) => (
          <li key={filename} className="assessment-item">
            <a
              href={`/assessments/${filename}`}
              target="_blank"
              rel="noopener noreferrer"
              className="assessment-link"
            >
              {filename.replace('.html', '').replace(/_/g, ' ')}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}

